/*!

=========================================================
* Paper Dashboard React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import {useParams} from "react";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Filler,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
import { Chart,Line } from 'react-chartjs-2';
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";
// core components
import {
  dashboard24HoursPerformanceChart,
  dashboardEmailStatisticsChart,
  dashboardNASDAQChart,
} from "variables/charts.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileLines } from '@fortawesome/free-solid-svg-icons'
import zoomPlugin from 'chartjs-plugin-zoom';
import Hammer from "hammerjs";
import { AvatarGenerator } from 'random-avatar-generator';
import TableAndAvgMetrics from "../components/TableAndAvgMetrics";
import { color } from "highcharts";



ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Filler,
  Tooltip,
  LineController,
  BarController,
  zoomPlugin
);


function ProjectMore(props) {
  // const searchParams = new URLSearchParams(props.location.search);
  // const name = searchParams.get('name');
  // const name = props.match.params.name;

  const generator = new AvatarGenerator();
  // var name=(new URLSearchParams(window.location.search)).get("name");
  // setProjectName(name);
  const [projectName, setProjectName] = React.useState((new URLSearchParams(window.location.search)).get("name"));
  const [cumulativeDebt, setCumulativeDebt] = React.useState(0);
  const [loc, setLoc] = React.useState(0);
  const [refactorings, setRefactorings] = React.useState(0);
  const [interestRate, setInterestRate] = React.useState(0.0);
  const [lessDebtDevelopers, setLessDebtDevelopers] = React.useState([]);
  const [moreRefactoringsDevelopers, setMoreRefactoringsDevelopers] = React.useState([]);
  const [dataChart, setDataChart] = React.useState({labels:[], datasets:[]});
  const [tableData, setTableData] = React.useState([]);
  const [lastWeeksDebt, setLastWeeksDebt] = React.useState(0);

  /**
   * Get file metrics data from API
   */
  const fetchFileMetricsData = async () => {
    console.log("Fetching file metrics data...");
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + '/project/allfilesmetricsanddebt?owner=' + process.env.REACT_APP_ORG +'&name='+projectName,
        {
          method: "GET",
          redirect: "follow",
          headers: {Authorization: `Bearer ${localStorage.getItem("accessToken")}`}
        }
      );
      const result = await response.json();
      if(response.status === 200) {
        var obj = JSON.parse(JSON.stringify(result));
        var t = [];
        for(var i=0; i<obj.files.length; i++) {
          t.push({file:obj.files[i].path, totaldebt:obj.files[i].totalDebt, k:obj.files[i].k,
            complexity:obj.files[i].fileMetrics.complexity, rfc:obj.files[i].fileMetrics.rfc,
            mpc:obj.files[i].fileMetrics.mpc, nom:obj.files[i].fileMetrics.nom, dac:obj.files[i].fileMetrics.dac,
            lcom:obj.files[i].fileMetrics.lcom, size1:obj.files[i].fileMetrics.size1, size2:obj.files[i].fileMetrics.size2});
        }
        setTableData(t);
      }
      else {
        console.log("API error:", result);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  /**
   * Get projects data from API
   */
  const fetchProjectData = async () => {
    console.log("Fetching projects data...");
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + '/project/mid?owner='+process.env.REACT_APP_ORG+'&name=' + projectName,
        {
          method: "GET",
          redirect: "follow",
          headers: {Authorization: `Bearer ${localStorage.getItem("accessToken")}`}
        }
      );
      const result = await response.json();
      if(response.status === 200) {
        var obj = JSON.parse(JSON.stringify(result));
        setCumulativeDebt(obj.cumulativeDebt);
        setLoc(obj.linesOfCode);
        setInterestRate(obj.interestRate);
        setRefactorings(obj.refactorings);
        setLessDebtDevelopers(obj.lessDebtDevelopers);
        setMoreRefactoringsDevelopers(obj.moreRefactoringsDevelopers);

        //get chart data
        var labels = [];
        var dataAdditional = [];
        var dataCumulative = [];
        var previousCumulative = 0;
        for(var i=0; i<obj.weekDebt.length; i++) {
          labels.push(obj.weekDebt[i].date);
          dataAdditional.push(obj.weekDebt[i].debt);
          previousCumulative += obj.weekDebt[i].debt;
          dataCumulative.push(previousCumulative);
        }
        var dataInterestRate =  [];
        for(var i=0; i<obj.interestRateList.length; i++) {
          dataInterestRate.push(obj.interestRateList[i].interestRate);
        }
        setLastWeeksDebt(obj.weekDebt[obj.weekDebt.length-1].debt);
        setDataChart({
          labels,
          datasets: [
            {
              type: 'bar',
              label: 'Additional Debt',
              borderWidth: 2,
              borderColor: 'rgba(251, 198, 88, 0.8)',
              backgroundColor: 'rgba(251, 198, 88, 0.7)',
              data: dataAdditional,
              hidden: true,
              yAxisID: 'y',
            },
            {
              type: 'bar',
              label: 'IR',
              borderWidth: 2,
              borderColor: 'rgba(251, 198, 188, 0.8)',
              backgroundColor: 'rgba(251, 198, 188, 0.7)',
              data: dataInterestRate,
              yAxisID: 'y',
            },
            {
              type: 'line',
              fill: true,
              label: 'Cumulative Debt',
              borderWidth: 2,
              backgroundColor: 'rgb(17 159 80)',
              data: dataCumulative,
              hidden: true,
              yAxisID: 'y1',
            },
          ],
        });
      }
      else {
        console.log("API error:", result);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  /**
   * Fetch data from API when component is mounted
   */
  React.useEffect(() => {
    console.log("...ProjectMore component mounted...");
    var name=(new URLSearchParams(window.location.search)).get("name");
    setProjectName(name);

    fetchProjectData();
    fetchFileMetricsData();
  }, []);

  /**
   * Reset zoom of chart
   */
  function reset(e) {
    ChartJS.getChart('chart').resetZoom();
  }

  return (
    <>
      <div className="content">
        <CardTitle tag="h5">{projectName}</CardTitle>
        <Row>
          <Col xl="3" lg="4" md="5" sm="12">
            <Row>
              <Col lg="12" md="12" sm="12">
                <Card className="card-stats">
                  <CardBody style={{paddingBottom:"15px"}}>
                    <Row>
                      <Col md="3" xs="5">
                        <div className="icon-big text-center icon-warning">
                          <i className="nc-icon nc-money-coins text-warning" />
                        </div>
                      </Col>
                      <Col md="9" xs="7">
                        <div className="numbers">
                          <p className="card-category">Cumulative Debt</p>
                          <CardTitle tag="p">{cumulativeDebt != null ? cumulativeDebt.toLocaleString(undefined, {maximumFractionDigits:2}) : 0} €</CardTitle>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="12" md="12" sm="12">
                <Card className="card-stats">
                  <CardBody style={{paddingBottom:"15px"}}>
                    <Row>
                      <Col md="3" xs="5">
                        <div className="icon-big text-center icon-warning">
                          <i className="nc-icon nc-money-coins text-warning" />
                        </div>
                      </Col>
                      <Col md="9" xs="7">
                        <div className="numbers">
                          <p className="card-category">Weeks Debt</p>
                          <CardTitle tag="p">{lastWeeksDebt != null ? lastWeeksDebt.toLocaleString(undefined, {maximumFractionDigits:2}) : 0} €</CardTitle>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="12" md="12" sm="12">
                <Card className="card-stats">
                  <CardBody style={{paddingBottom:"15px"}}>
                    <Row>
                      <Col md="3" xs="5">
                        <div className="icon-big text-center icon-warning">
                          <i className="nc-icon nc-bank" style={{color:"rgb(251, 198, 188)"}} />
                        </div>
                      </Col>
                      <Col md="9" xs="7">
                        <div className="numbers">
                          <p className="card-category">Interest Rate</p>
                          <CardTitle tag="p">{interestRate != null ? (interestRate*100).toLocaleString(undefined, {maximumFractionDigits:2}) : 0} %</CardTitle>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
                  <Col xl="6" lg="6" md="6" sm="6">
                    <Card className="card-stats">
                      <CardBody style={{paddingBottom:"15px"}}>
                        <Row>
                          <Col md="4" xs="5">
                            <div className="icon-big text-center icon-warning">
                              <FontAwesomeIcon icon={faFileLines} style={{color: "#119f50",}} />
                            </div>
                          </Col>
                          <Col md="8" xs="7">
                            <div className="numbers">
                              <p className="card-category">LoC</p>
                              <CardTitle tag="p">{loc != null ? loc.toLocaleString() : 0}</CardTitle>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xl="6" lg="6" md="6" sm="6">
                    <Card className="card-stats">
                      <CardBody style={{paddingBottom:"15px"}}>
                        <Row>
                          <Col md="4" xs="5">
                            <div className="icon-big text-center icon-warning">
                              <i className="nc-icon nc-vector text-danger" />
                            </div>
                          </Col>
                          <Col md="8" xs="7">
                            <div className="numbers">
                              <p className="card-category">Refactorings</p>
                              <CardTitle tag="p">{refactorings != null ? refactorings.toLocaleString() : 0}</CardTitle>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
            </Row>
          </Col>
          <Col xl="9" lg="8" md="7" sm="12">
            <Row>
              <Col md="12">
                <Card>
                  <CardHeader style={{display:"flex", justifyContent:"space-between"}}>
                    <div>
                      <CardTitle tag="h5">Debt / IR</CardTitle>
                    </div>
                    <div style={{marginTop:"auto"}}>
                      <button className="btn btn-secondary btn-round" style={{float:"right", marginRight:"10px"}} onClick={reset}>Reset Zoom</button>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <Chart id="chart" data={dataChart} options=
                      {{maintainAspectRatio:false, 
                        plugins: {
                          zoom: {
                            zoom: {
                              wheel: {
                                enabled: true
                              },
                              mode: "x",
                              speed: 100
                            },
                            pan: {
                              enabled: true,
                              mode: "xy",
                              speed: 0.5
                            }
                          }
                        },
                        scales: {
                          y: {
                            type: 'linear',
                            display: true,
                            position: 'left',
                          },
                          y1: {
                            type: 'linear',
                            display: true,
                            position: 'right',
                            grid: {
                              drawOnChartArea: false,
                            },
                          }
                        },
                      }} width={400} height={400} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h5">Metrics</CardTitle>
              </CardHeader>
              <CardBody>
                {tableData.length!=0 ? <TableAndAvgMetrics data={tableData} /> : "" }
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <Card>
              <CardHeader>
                <CardTitle tag="h5">Cleaner Contributors</CardTitle>
              </CardHeader>
              <CardBody>
                {lessDebtDevelopers.map((developer, index) => (
                  <Row style={{marginBottom: "5px"}}>
                    <Col md="1" xs="1" style={{margin:"auto", padding:"4px"}}>
                      <div style={{textAlign:"center"}}>{index+1}.</div>
                    </Col>
                    <Col md="3" xs="3" style={{margin:"auto"}}>
                      <img src={developer.avatarUrl!=null ? developer.avatarUrl : generator.generateRandomAvatar(developer.name)} style={{borderRadius: "50%", width:"70px"}}/>
                    </Col>
                    <Col md="4" xs="3" style={{margin:"auto"}}>
                      <div>{developer.name}</div>
                    </Col>
                    <Col md="4" xs="3" style={{margin:"auto", textAlign:"center"}}>
                      <div>Debt per Line:</div>
                      <div> {(developer.debtAddition / developer.linesOfCodeAddition).toFixed(2)==0.00 ? (developer.debtAddition / developer.linesOfCodeAddition).toFixed(4) : (developer.debtAddition / developer.linesOfCodeAddition).toFixed(2)} €</div>
                    </Col>
                  </Row>
                ))}
              </CardBody>
            </Card>
          </Col>
          <Col md="6">
            <Card>
              <CardHeader>
                <CardTitle tag="h5">Most Refactoring Contributors</CardTitle>
              </CardHeader>
              <CardBody>
                {moreRefactoringsDevelopers.map((developer, index) => (
                  <Row style={{marginBottom: "5px"}}>
                    <Col md="1" xs="1" style={{margin:"auto", padding:"4px"}}>
                      <div style={{textAlign:"center"}}>{index+1}.</div>
                    </Col>
                    <Col md="3" xs="3" style={{margin:"auto"}}>
                      <img src={developer.avatarUrl!=null ? developer.avatarUrl : generator.generateRandomAvatar(developer.name)} style={{borderRadius: "50%", width:"70px"}}/>
                    </Col>
                    <Col md="4" xs="3" style={{margin:"auto"}}>
                      <div>{developer.name}</div>
                    </Col>
                    <Col md="4" xs="3" style={{margin:"auto", textAlign:"center"}}>
                      <div>Refactorings</div>
                      <div>{developer.numberOfRefactorings.toLocaleString()}</div>
                    </Col>
                  </Row>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ProjectMore;
